import React from "react";
import { styled } from '@pixel/core/styles';
const RootDiv = styled('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    borderTop: "solid 1px " + theme.palette.pixelContrast.fades.softer,
    padding: theme.spacing(1, 0),
    display: "flex",
    flexFlow: "row"
  };
});
const PrimaryDiv = styled('div')(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    order: 2,
    textAlign: "right",
    flex: 1,
    "& button": {
      margin: theme.spacing(0, 0.25)
    }
  };
});
const SecondaryDiv = styled('div')(() => ({
  secondary: {
    order: 1,
    flex: 1,
    textAlign: "left"
  }
}));
;
const LayoutPageButtons = _ref3 => {
  let {
    noDivider = false,
    secondaryButtons,
    children,
    ...restProps
  } = _ref3;
  const typedRestProps = restProps;
  return /*#__PURE__*/React.createElement(RootDiv, typedRestProps, /*#__PURE__*/React.createElement(PrimaryDiv, null, children), secondaryButtons && /*#__PURE__*/React.createElement(SecondaryDiv, null, secondaryButtons));
};
export default LayoutPageButtons;